
<template>



 <!-- 租主才能使用 -->
	<section>
		
		
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getMember" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getMember" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="Export">备份业务</el-button>
				</el-form-item>					
			</el-form>
		</el-col>

		<!--列表-->
		<el-table   :data="Members" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60" hidden>
			</el-table-column> -->
			<el-table-column prop="CardNumber" label="卡号" width="140" sortable>
			</el-table-column>
			<!-- <el-table-column prop="WeChatOrderNumber" label="订单号" width="260" sortable>
			</el-table-column> -->
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Sex" label="性别" width="100" :formatter="formatSex" sortable>
			</el-table-column>
			<el-table-column prop="Age" label="年龄" width="100" sortable>
			</el-table-column>
			<el-table-column prop="Telephone" label="电话" width="150" sortable>
			</el-table-column>
			<el-table-column prop="Birthday" label="生日" width="120" sortable :formatter="formatDate">
			</el-table-column>
						<el-table-column prop="Height" label="身高cm" min-width="110" sortable>
			</el-table-column>
						<el-table-column prop="ArmLength" label="臂长cm" min-width="110" sortable>
			</el-table-column>
						<el-table-column prop="Weight" label="体重kg" min-width="110" sortable>
			</el-table-column>	
			<el-table-column prop="IdNumber" label="身份证号码" width="190" sortable>
			</el-table-column>
			<el-table-column prop="CardType" label="卡类型" min-width="100" :formatter="formatType" sortable>
			</el-table-column>

            <!-- <el-table-column prop="WeChatCurriculumInfo" label="课程信息" width="100" >
			</el-table-column>
			<el-table-column prop="WeChatCurriculumIntervalInfo" label="课程时段" width="140" >
			</el-table-column>			
             <el-table-column prop="WeChatCurriculumTimeInfo" label="课程时间" width="140" >
			</el-table-column>     -->
             <el-table-column prop="WeChatOrderAmount" label="订单金额" width="100" >
			</el-table-column>  
			<el-table-column prop="WeChatOrderTime" label="下单时间" width="200" >
			</el-table-column>         
			             
            <el-table-column prop="WeChatPaymentTime" label="付款时间" width="200" >
			</el-table-column>          
            <!-- <el-table-column prop="InfoType" label="信息源" width="100" >
			</el-table-column>                -->
			<el-table-column prop="State" label="办理状态" min-width="120" :formatter="formatState" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Address" label="地址" min-width="200" sortable>
			</el-table-column>
            <el-table-column prop="State" label="办理状态" width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==0">已办理</el-tag>
                  <el-tag type="success" size="medium" v-else>未处理</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="120"  fixed="right" >
				<template  slot-scope="scope">
					<el-button v-if="scope.row.State!=0" type="primary" size="small" @click="AddMember(scope.$index, scope.row)">激活会员</el-button>
                    <el-button v-else :disabled="true" type="primary" size="small" @click="AddMember(scope.$index, scope.row)">激活会员</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar" >
			<el-tag>共{{Count}}位微信会员</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
<!--  -->
 
  <el-dialog  title="请检查读卡器是否连接" custom-class style="width:1000px;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="Machine" :close-on-click-modal="false" >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
      <!-- <img v-bind:src="IdCard" class="image"> -->
      <div >      
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form v-if="cardType=='4'" :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-button  style="float:right;margin-right:1px" type="primary" v-on:click="BusinessHandle" icon="el-icon-search">确认激活</el-button>
			
				
        <!-- <span>请检查读卡器</span> -->
				<el-select style="width:25%;float:right;margin-right:1px" v-model="CoachId" clearable filterable placeholder="选择教练">
                 <el-option
               v-for="item in coachOptions"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>
                   <!-- @keyup.enter="BusinessHandle" -->
					<input  :autofocus="focusvalue" ref="siteInput"  class="input" style="width:30%;float:right;margin-right:1px" v-model="inputIdCard"  clearable   placeholder="卡号"></input>
				    <input class="input" style="width:18%;float:right;margin-right:1px" v-model="classhour" auto-complete="off" placeholder="赠送课时"></input>             
				<!-- </el-form-item>
				<el-form-item> -->
				</el-form-item>
			</el-form>
			<el-form v-if="cardType=='0'||cardType=='1'||cardType=='2'||cardType=='3'" :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-button  style="float:right;margin-right:1px" type="primary" v-on:click="BusinessHandle" icon="el-icon-search">确认激活</el-button>
						
                   <!-- @keyup.enter="BusinessHandle" -->
					<input  :autofocus="focusvalue" ref="siteInput"  class="input" style="width:55%;float:right;margin-right:1px" v-model="inputIdCard"  clearable   placeholder="卡号"></input>
				    <!-- <input class="input" style="width:18%;float:right;margin-right:1px" v-model="classhour" auto-complete="off" placeholder="赠送课时"></input>              -->
				<!-- </el-form-item>
				<el-form-item> -->
				</el-form-item>
			</el-form>			
		</el-col>
        </div>
      </div>
    </el-card>
    </el-col>
   </el-row>	
  </el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {ExportBusiness,getCoachOptionsList, ChangeWeChatInfo,getWeChatMemberListPage ,getMemberCount,AddMember,getMonthCardOptionsList ,getYearCardOptionsList} from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					Name: ''
				},
			   //已办理未办理
			   classhour:'',
                Count:0,
                Handled:0,
                NotHandled:0,

				options:[],
				// monthOptions:[],
				// yearOptions:[],
				Members:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
				//会员id
				Machine:false,
				inputIdCard:"",
				focusvalue:false,
				cardType:"",
				WeChatMemberId:"",
				CoachId:"",
				coachOptions:[],
				//
				ResetMachine:false,
				currRow:{}
			}
			
		},
		methods: {
			Export(){


		   let para={
		   }
		   ExportBusiness(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = "微信业务备份"; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })		   
			},
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			formatState: function (row, column) {
				return row.State == 1 ? '未办理' : row.State == 0 ? '已办理' : '未知';
			},
			//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			formatType: function (row, column) {
				return row.CardType == 0 ? '次卡' : row.CardType == 1 ? '月卡' : row.CardType == 2 ? '年卡': row.CardType == 3 ? '充值卡': row.CardType == 4 ? '培训卡': row.CardType==5?'业主卡':'未知';
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getMember();
			},

			OptionsList()
			{
				let para={}
             getCoachOptionsList(para).then((res)=>{
					//  console.log(res);
             this.coachOptions=res.data;
				 }).catch(error=>{
             })      
			},
			   
        
			getCount()
			{
              let para={
                  
			  };
			//   getMemberCount(para).then((res)=>{
            //       this.Count=res.data.Date.Acount;
            //       this.Handled=res.data.Date.Handled;
            //       this.NotHandled=res.data.Date.NotHandled;
                
			//   }).catch(error=>{
            //      alert('网络错误');
            //     });
            },
            //获取用户列表
			getMember() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name
				};
				this.listLoading = true;
				//NProgress.start();
				getWeChatMemberListPage(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//  console.log(res);
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.Members =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
		
		    // ResetCard:function(){
			// 	   this.ResetMachine=true;
            //       this.focusvalue=true;
            //       this.onCellClick(event);
			// },

            AddMember:function(index,row){
				this.currRow=row;
				this.inputIdCard='';
                  this.WeChatMemberId=row.Id;
				   this.Machine=true;
				  this.focusvalue=true;
				  this.cardType=row.CardType;
				  if(row.cardType='4')
				  {
					  this.classhour='';
					this.OptionsList();
				  }
				//   if(row.cardType='1')
				//   {
				// 	this.monthOptionsList();
				//   }
				//   if(row.cardType='2')
				//   {
				// 	  this.yearOptionList();
				//   }
                  this.onCellClick(event);
			},			
			//
             BusinessHandle(){
                  switch (this.cardType) {
					  case '0':
						  {
							  this.FrequencyCard();
						  break;}
				      case '1':
						  {
							  this.MonthyCard();
						  break;}
					  case '2':
						  { 
							  this.YearCard();
					      break;}
				      case '3':
						  {
                            this.RechargeableCard();
						  break;}
					  case '4':
						  {
							this.TrainingCard();
						  break;}
					  default:
						  break;
				  }

			 },		
			 RechargeableCard()
			 {
               let para={
				    WeChatMemberId:this.WeChatMemberId,
					CardNumber:this.inputIdCard ,
			   }
			   
			    if(this.inputIdCard=="")
				  {
					  this.$message({
							message: '请输入卡号',
							type: 'error'
						});
						return ;
				}
                   ChangeWeChatInfo(para).then((res)=>{
					//    console.log(res);
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.currRow.State=0;
						this.currRow.CardNumber=para.CardNumber;
						// this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";

			 },
			 YearCard()
			 {
               let para={
				    WeChatMemberId:this.WeChatMemberId,
					CardNumber:this.inputIdCard ,
			   }
			   
			    if(this.inputIdCard=="")
				  {
					  this.$message({
							message: '请输入卡号',
							type: 'error'
						});
						return ;
				}
                   ChangeWeChatInfo(para).then((res)=>{
					//    console.log(res);
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.currRow.State=0;
						this.currRow.CardNumber=para.CardNumber;
						// this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";

			 },
			//  yearOptionList()
			//  {
			// 	 let para={}
			//     getYearCardOptionsList(para).then((res)=>{
			// 		//  console.log(res);
            //       this.yearOptions=res.data;
			// 	 }).catch(error=>{
			// 	 })

			//  },
			//  monthOptionsList()
			//  {
			// 	 let para={}
			//     getMonthCardOptionsList(para).then((res)=>{
			// 		//  console.log(res);
            //       this.monthOptions=res.data;
			// 	 }).catch(error=>{
			// 	 })
			//  },
			 MonthyCard()
			 {
               let para={
				    WeChatMemberId:this.WeChatMemberId,
					CardNumber:this.inputIdCard ,
			   }
			   
			    if(this.inputIdCard=="")
				  {
					  this.$message({
							message: '请输入卡号',
							type: 'error'
						});
						return ;
				}
                   ChangeWeChatInfo(para).then((res)=>{
					//    console.log(res);
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.currRow.State=0;
						this.currRow.CardNumber=para.CardNumber;
						// this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";
			 },
			 FrequencyCard()
			 {
               let para={
				    WeChatMemberId:this.WeChatMemberId,
					CardNumber:this.inputIdCard ,
			   }
			   
			    if(this.inputIdCard=="")
				  {
					  this.$message({
							message: '请输入卡号',
							type: 'error'
						});
						return ;
				}
                   ChangeWeChatInfo(para).then((res)=>{
					//    console.log(res);
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.currRow.State=0;
						this.currRow.CardNumber=para.CardNumber;
						// this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";
			 },
	     	 TrainingCard()
			  {
				 	let para={
                    WeChatMemberId:this.WeChatMemberId,
					CardNumber:this.inputIdCard ,
					CoachId:this.CoachId,
					Classhour:this.classhour==''?0:this.classhour
				  }
				  if(this.inputIdCard=="")
				  {
					  this.$message({
							message: '请输入卡号',
							type: 'error'
						});
						return ;
				  }
				  if(this.CoachId=="")
				  {
					  this.$message({
							message: '请选择教练',
							type: 'error'
						});
						return ;
				  }
				  ChangeWeChatInfo(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.currRow.State=0;
						this.currRow.CardNumber=this.inputIdCard;
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";
			 },
			selsChange: function (sels) {
				this.sels = sels;
			},
		
   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getMember();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
    
  
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// WeChatMember.vue?583185ed